import React, { Fragment, useEffect, useState } from "react";
import DataTable from "../../../Common/Components/DataTable";
import { GetData, DeleteData, EditData } from "./Components/Services";
import Loading from "../../../Common/Components/Loading";
import { Helmet } from "react-helmet";
import CustomModal from "../../../Common/Components/Modal/CustomModal";
import CommonFrom from "../../../Common/Components/Form";
import { input } from "./Create";
function List() {
  const initialState = {
    loading: false,
    data: {
      data: null,
      current_page: null,
    },
    modal: false,
  };
  const [state, setstate] = useState(initialState);
  const [filter, setfilter] = useState({});

  useEffect(() => {
    Handler();
  }, []);

  const Handler = (pageNumber = 1, limit) => {
    setstate({ ...state, loading: true });
    GetData(pageNumber, limit, filter).then(result => {
      setstate({
        loading: false,
        data: result,
      });
    });
  };

  const HandlerDelete = data => {
    setstate({ ...state, loading: true });
    DeleteData(data).then(() => {
      GetData().then(result => {
        setstate({
          loading: false,
          data: result,
        });
      });
    });
  };
  const HandlerEdit = data => {
    setstate({ ...state, loading: true });
    EditData({ ...data, admin_id: state.data.data[state.modal - 1].id }).then(
      () => {
        GetData().then(result => {
          setstate({
            loading: false,
            data: result,
          });
        });
      }
    );
  };
  return (
    <Fragment>
      <Helmet>
        <title>نیکوتن | لیست مجموعه ها</title>
      </Helmet>

      <DataTable
        heads={[
          {
            title: "عنوان",
            key: "fullname",
          },
          {
            title: "ایمیل",
            key: "email",
          },
          {
            title: "موبایل",
            key: "mobile",
          },
          {
            title: "جنسیت",
            key: "gender",
            type: "enum",
            enum: {
              woman: "خانم",
              man: "آقا",
            },
          },
          {
            title: "نوع کاربر",
            key: "role",
            type: "enum",
            enum: {
              supporter: "پشتیبان",
              financial: "امور مالی",
              contentmaker: "تولید محتوا",
            },
          },
          {
            title: "کد ملی",
            key: "national_code",
          },
          {
            title: "زمان ثبت اطلاعات",
            key: "created_at",
            type: "date",
            timetype: "date-time",
          },
        ]}
        textEmpty="کاربری ثبت نشده"
        list={state.data.data}
        data={state.data}
        function={Handler}
        currentPage={state.data.current_page}
        header=" لیست اطلاعات کاربران"
        textbtn="ثبت اطلاعات کاربر"
        linkbtn="/Admin/admin/Create"
        loading={state.loading}
        links={[
          {
            html: (
              <select
                onChange={e => {
                  setfilter({ ...filter, role: e.target.value });
                }}
                className="form-control col-12"
              >
                <option value={""}> نوع مدیر</option>
                <option value={""}> مشاهده همه </option>
                <option value={"support"}>پشتیبانی</option>
                <option value={"financial"}>مالی</option>
                <option value={"contentmaker"}> تولید محتوا</option>
              </select>
            ),
          },
          {
            function: () => {
              Handler(null, null, filter);
            },
            color: "info",
            size: "col-md-4",
            html: "فیلتر",
            undisabled: true,
          },
          {
            function: selected => {
              HandlerDelete({ admin_id: selected });
            },
            color: "danger",
            size: "col-md-2",
            html: "حذف",
            multi: true,
            type: "delete",
          },
          {
            function: selected => {
              setstate({ ...state, modal: selected[0] });
            },
            color: "info",
            type: "key",
            size: "col-md-2",
            html: "ویرایش",
            type: "edit",
            main: true,
          },
        ]}
      />

      <CustomModal
        show={state.modal}
        handleClose={() => {
          setstate({ ...state, modal: false });
        }}
        header={"ویرایش اطلاعات کاربر"}
      >
        <CommonFrom
          loading={state.loading}
          form={input}
          btnName={"ثبت اطلاعات کاربر"}
          value={
            state.data && state.data.data && state.data.data[state.modal - 1]
          }
          submit={HandlerEdit}
        />
      </CustomModal>
    </Fragment>
  );
}

export default List;
